export const CONNECTIONS_API = 'v1/connections';
export const CONNECTION_REMOVE_API = 'v1/connections/remove';
export const CONNECTION_BLOCKS_API = 'v1/connections/blocks';
export const CONNECTION_UNBLOCK_API = 'v1/connections/blocks/remove';
export const PLAYED_WITH_DISMISS_API = 'v1/connections/played-with/dismiss';
export const PLAYED_WITH_RESTORE_API = 'v1/connections/played-with/restore';
export const GAME_INVITES_API = 'v1/game-invites';
export const GAME_INVITES_CANCEL_API = 'v1/game-invites/cancel';

export const getConnectionRequestAcceptApi = (requestId: string) =>
  `v1/connections/requests/${requestId}/accept`;
export const getConnectionRequestDeclineApi = (requestId: string) =>
  `v1/connections/requests/${requestId}/decline`;
export const getConnectionRequestCancelApi = (requestId: string) =>
  `v1/connections/requests/${requestId}/cancel`;
export const getGameInviteAcceptApi = (inviteId: string) => `v1/game-invites/${inviteId}/accept`;
export const getGameInviteDeclineApi = (inviteId: string) => `v1/game-invites/${inviteId}/decline`;

/** Caps the request note. Enforced server-side on create; also caps the textarea. */
export const MAX_CONNECTION_REQUEST_MESSAGE_LENGTH = 500;
/**
 * Matches the DB check on `attempt_number`: a player gets one retry after a
 * decline, and the second decline is where the recipient is offered the block.
 */
export const MAX_CONNECTION_REQUEST_ATTEMPTS = 2;
/** Most players a host can invite to one game in a single submit. */
export const MAX_GAME_INVITES_PER_SUBMIT = 20;

// Failures on every route below go through the shared response4xx/response500
// wrappers, which send `{ message, statusCode }` — read the error off the failed
// response rather than expecting an `error` field in these bodies.

export interface CreateConnectionRequestPayload {
  recipientUserId: string;
  message?: string;
}

export interface CreateConnectionRequestResponse {
  success: boolean;
  requestId?: string;
  /** True when the recipient had already requested the viewer, so this connected them. */
  isConnected?: boolean;
}

export interface RemoveConnectionPayload {
  otherUserId: string;
}

export interface BlockPlayerPayload {
  blockedUserId: string;
}

export interface PlayedWithDismissalPayload {
  dismissedUserId: string;
}

export interface CreateGameInvitesPayload {
  eventId: string;
  invitedUserIds: string[];
}

export interface CreateGameInvitesResponse {
  success: boolean;
  /** Ids actually invited — already-invited players are skipped, not an error. */
  invitedUserIds?: string[];
}

export interface CancelGameInvitesPayload {
  eventId: string;
  invitedUserIds: string[];
}

export interface ConnectionActionResponse {
  success: boolean;
}

export interface AcceptGameInviteResponse {
  success: boolean;
  conversationId?: string;
}
